// extracted by mini-css-extract-plugin
module.exports = {"backTopWrapper":"backToTop_backTopWrapper__5tIJ5"};